import { __asyncGenerator, __asyncValues, __await } from "tslib";
import { AsyncIterableX } from '../asynciterablex.mjs';
import { wrapWithAbort } from './withabort.mjs';
import { throwIfAborted } from '../../aborterror.mjs';
/** @ignore */
export class TakeAsyncIterable extends AsyncIterableX {
    constructor(source, count) {
        super();
        this._source = source;
        this._count = count;
    }
    [Symbol.asyncIterator](signal) {
        return __asyncGenerator(this, arguments, function* _a() {
            var _b, e_1, _c, _d;
            throwIfAborted(signal);
            let i = this._count;
            if (i > 0) {
                try {
                    for (var _e = true, _f = __asyncValues(wrapWithAbort(this._source, signal)), _g; _g = yield __await(_f.next()), _b = _g.done, !_b; _e = true) {
                        _d = _g.value;
                        _e = false;
                        const item = _d;
                        yield yield __await(item);
                        if (--i === 0) {
                            break;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (!_e && !_b && (_c = _f.return)) yield __await(_c.call(_f));
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        });
    }
}
/**
 * Returns a specified number of contiguous elements from the start of an async-iterable sequence.
 *
 * @template TSource The type of the elements in the source sequence.
 * @param {number} count The number of elements to return.
 * @returns {MonoTypeOperatorAsyncFunction<TSource>} An async-iterable sequence that contains the specified
 * number of elements from the start of the input sequence.
 */
export function take(count) {
    return function takeOperatorFunction(source) {
        return new TakeAsyncIterable(source, count);
    };
}

//# sourceMappingURL=take.mjs.map
